module.exports = __webpack_public_path__ + "static/media/weChatPay.6d6402a2.png";